<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HQUmEB/tc-custom/9781504073097.jpg?1723836043038" alt="This image is the cover for the book Whiskey Tango Foxtrot, The Constable Mavis Upton Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Whiskey Tango Foxtrot, The Constable Mavis Upton Series
      </h1>
      <p class="bookDescription body article font2">
        <b>For Mavis Upton, there’s a fine (blue) line between being a parent and a police officer in this sequel to <i>Handcuffs, Truncheon and a Polyester Thong</i>.</b><br/>  <br/> Our hapless heroine Constable Mavis Upton is preparing to step down the aisle with her fiancé Joe, but has to deal with her temperamental teen daughter, as well as investigate a serial flasher on a push bike. Throw a diva drag queen into the mix and readers can expect the usual hilarious Mavis mishaps that made the first book such a hit.<br/>  <br/> Revel in Gina Kirkham’s humorous, poignant and moving stories of an everyday woman who one day followed a dream.<br/>  <br/><b>Series praise</b><br/>  <br/> “Laugh out loud brilliance, so witty and cleverly written.” —Samantha Magson<br/>  <br/> “Hilarious! It’s true, everyone needs Mavis in their life.” —Sherrie Hewson<br/>  <br/> “Such a terrific read!” —Lorraine Kelly
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gina Kirkham
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?46d443ce